import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ObjectionDialog = ({ permit, onClose, onDone }) => {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const send = async () => {
    setSaving(true);
    try {
      const { data } = await axios.post(`${API}/firm/store-incoming-permits/${permit.id}/objection`, { note });
      toast.success('İtirazınız İSG birimine iletildi');
      onDone(permit.id, data.store_objection);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'İtiraz gönderilemedi');
    } finally { setSaving(false); }
  };
  return (
    <Dialog open={!!permit} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="objection-dialog">
        <DialogHeader>
          <DialogTitle>Bilgim dahilinde değil</DialogTitle>
          <DialogDescription>
            <b>{permit?.request_number}</b> nolu <b>{permit?.company_name}</b> talebinin bilginiz dahilinde olmadığı İSG birimine e-posta ile bildirilecek.
          </DialogDescription>
        </DialogHeader>
        <Textarea value={note} onChange={e => setNote(e.target.value)} maxLength={500} rows={3} placeholder="Kısa açıklama (isteğe bağlı)" data-testid="objection-note" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving} data-testid="objection-cancel">Vazgeç</Button>
          <Button className="bg-rose-600 hover:bg-rose-700" onClick={send} disabled={saving} data-testid="objection-submit">{saving ? 'Gönderiliyor...' : 'İSG\'ye Bildir'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
